export default __webpack_public_path__ + "static/begaiym-0e455c916cecaa0861a3ec883fc84d30.jpg";